import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

export default function Configuration() {
  return (
    <Box sx={{ width: "100%" }}>
      <Outlet />
    </Box>
  );
}
